import React from 'react';
import imgSrc from '../images/brand-5.png';

const Brand = () => (
  <img src={imgSrc} width="67px" alt="Henry Salcedo" className="watermelon-logo" />
);

export default Brand;
